// Mock data for MeisterGrün Website
import heroImage from '../assets/Hero_Meistergrün.webp';
import logoImage from '../assets/new_logo_meistergrun_weiss.png';

export const companyInfo = {
  name: "MeisterGrün",
  tagline: "Ihr zuverlässiger Hausmeisterservice",
  subline: "Hausmeister-Dienstleistungen, Gartenarbeit und kleine Reparaturen in Frankfurt, Kahl am Main und Umgebung",
  phone: "0162 60 60 140",
  email: "info@meistergrün.de",
  address: {
    street: "Portenstr. 2",
    city: "Kahl am Main",
    zip: "63796"
  }
};

export const services = [
  {
    id: 1,
    title: "Hausmeisterservice",
    description: "Komplette Hausmeisterdienstleistungen für Innen- und Außenbereiche. Regelmäßige Kontrollen, Winterdienst und Gebäudebetreuung.",
    icon: "Building2"
  },
  {
    id: 2,
    title: "Gartenpflege",
    description: "Professionelle Gartenarbeit inklusive Rasenmähen, Heckenschnitt, Unkrautentfernung und saisonale Bepflanzung.",
    icon: "TreeDeciduous"
  },
  {
    id: 3,
    title: "Außenanlagen",
    description: "Pflege und Instandhaltung von Außenanlagen, Wegen, Einfahrten und Gemeinschaftsflächen.",
    icon: "Fence"
  },
  {
    id: 4,
    title: "Kleine Reparaturen",
    description: "Handwerkliche Kleinarbeiten wie Türen einstellen, Lampen montieren, Möbelaufbau und mehr.",
    icon: "Wrench"
  },
  {
    id: 5,
    title: "Reinigungsarbeiten",
    description: "Treppenhausreinigung, Gehwegreinigung und allgemeine Sauberkeit in Ihren Liegenschaften.",
    icon: "Sparkles"
  },
  {
    id: 6,
    title: "Winterdienst",
    description: "Zuverlässiger Winterdienst mit Schneeräumung und Streudienst für sichere Wege.",
    icon: "Snowflake"
  }
];

export const notOffered = [
  "Gas-Installationen",
  "Elektroinstallationen",
  "Wasserinstallationen",
  "Sanitärarbeiten"
];

export const benefits = [
  {
    id: 1,
    title: "Zuverlässigkeit",
    description: "Pünktlich und verlässlich - Sie können sich auf uns verlassen.",
    icon: "Shield"
  },
  {
    id: 2,
    title: "Faire Preise",
    description: "Transparente und faire Preisgestaltung ohne versteckte Kosten.",
    icon: "BadgeEuro"
  },
  {
    id: 3,
    title: "Lokaler Service",
    description: "Vor Ort in Frankfurt und Kahl am Main - schnell und flexibel erreichbar.",
    icon: "MapPin"
  },
  {
    id: 4,
    title: "Qualitätsarbeit",
    description: "Sorgfältige Ausführung aller Arbeiten mit Liebe zum Detail.",
    icon: "Award"
  }
];

export const navItems = [
  { id: "home", label: "Home" },
  { id: "leistungen", label: "Leistungen" },
  { id: "ueber-uns", label: "Über uns" },
  { id: "service-gebiet", label: "Service-Gebiet" },
  { id: "kontakt", label: "Kontakt" }
];

export const images = {
  hero: heroImage,
  gardener: "https://images.unsplash.com/photo-1724556295135-ff92b9aa0a55?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwzfHxnYXJkZW4lMjBtYWludGVuYW5jZXxlbnwwfHx8fDE3NjczOTUwNzN8MA&ixlib=rb-4.1.0&q=85",
  maintenance: "https://images.pexels.com/photos/11280958/pexels-photo-11280958.jpeg",
  repair: "https://images.unsplash.com/photo-1635424824849-1b09bdcc55b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxwcm9wZXJ0eSUyMG1haW50ZW5hbmNlfGVufDB8fHx8MTc2NzM5NTA3OHww&ixlib=rb-4.1.0&q=85",
  tools: "https://images.unsplash.com/photo-1765518440022-10242cc86895?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxyZXBhaXIlMjB0b29sc3xlbnwwfHx8fDE3NjczOTUwODN8MA&ixlib=rb-4.1.0&q=85",
  toolsWood: "https://images.pexels.com/photos/1029243/pexels-photo-1029243.jpeg",
  logo: logoImage
};
